/* ============================================================
   Quelton — páginas: guía de tallas (modelos ↔ tabla, talla guardada),
   historia en horizontal y frase que se ilumina (Quiénes somos).
   El cuestionario de talla ([data-quiz-open]), los carriles ([data-scroll-prev/next])
   y las apariciones (.reveal) los gestiona q-theme.js.
   ============================================================ */
(function () {
  'use strict';
  if (window.QPagesLoaded) return;
  window.QPagesLoaded = true;

  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function init() {
    // ---------- guía de tallas: al elegir (o pasar por encima de) una chica se marca su talla en la tabla, y al revés ----------
    $$('[data-sz-models]').forEach((grid) => {
      const scope = grid.closest('.shopify-section')?.parentElement || document;
      const models = $$('.sz-model', grid);
      const rows = $$('[data-sz-table] tr[data-sz]', scope);
      let picked = null;
      const mark = (size) => {
        models.forEach((m) => m.classList.toggle('is-on', m.dataset.sz === size));
        rows.forEach((r) => r.classList.toggle('is-match', r.dataset.sz === size));
      };
      models.forEach((m) => {
        m.addEventListener('mouseenter', () => mark(m.dataset.sz));
        m.addEventListener('mouseleave', () => mark(picked));
        m.addEventListener('click', () => {
          picked = picked === m.dataset.sz ? null : m.dataset.sz;
          models.forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.sz === picked)));
          mark(picked);
        });
      });
      rows.forEach((r) => {
        r.addEventListener('mouseenter', () => mark(r.dataset.sz));
        r.addEventListener('mouseleave', () => mark(picked));
      });
    });

    // ---------- talla guardada con "Adivina tu talla" ----------
    $$('[data-saved]').forEach((out) => {
      const show = (v) => {
        if (!v || !v.top) return;
        out.hidden = false;
        out.innerHTML = (out.dataset.tpl || '')
          .replace('[top]', esc(v.top))
          .replace('[bottom]', esc(v.bottom || v.top))
          .replace('[url]', esc(out.dataset.link || '/collections/all'));
      };
      try { show(JSON.parse(localStorage.getItem('quelton-size'))); } catch (e) { /* sin almacenamiento */ }
      document.addEventListener('quelton:size', (e) => show(e.detail));
    });

    // ---------- historia en horizontal ----------
    // La sección mide lo que ocupa el recorrido; al bajar, la tira se desplaza hacia la izquierda.
    // En móvil (o con "reducir movimiento") se ve en vertical, sin desplazamiento lateral.
    $$('[data-hstory]').forEach((section) => {
      const track = section.querySelector('[data-hstory-track]');
      const bar = section.querySelector('[data-hstory-bar]');
      const word = section.querySelector('[data-hstory-word]');
      if (!track) return;
      const mq = window.matchMedia('(min-width: 901px)');
      let distance = 0;
      const active = () => mq.matches && !reduce;
      function update() {
        if (!active()) return;
        const top = section.getBoundingClientRect().top;
        const prog = Math.min(1, Math.max(0, -top / Math.max(1, distance)));
        track.style.transform = `translate3d(${(-prog * distance).toFixed(1)}px, 0, 0)`;
        if (word) word.style.transform = `translate3d(${(-prog * distance * 0.25).toFixed(1)}px, -50%, 0)`;
        if (bar) bar.style.width = `${prog * 100}%`;
      }
      function measure() {
        if (!active()) { section.style.height = ''; track.style.transform = ''; if (word) word.style.transform = ''; return; }
        distance = Math.max(0, track.scrollWidth - window.innerWidth);
        section.style.height = `${distance + window.innerHeight}px`;
        update();
      }
      let tick = false;
      window.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(() => { update(); tick = false; }); } }, { passive: true });
      window.addEventListener('resize', measure);
      if (mq.addEventListener) mq.addEventListener('change', measure);
      $$('img', track).forEach((i) => i.complete || i.addEventListener('load', measure));
      measure();
    });

    // ---------- frase que se ilumina palabra a palabra ----------
    $$('[data-words]').forEach((el) => {
      if (el.dataset.wordsReady) return;
      el.dataset.wordsReady = '1';
      el.innerHTML = el.textContent.trim().split(/\s+/).map((w) => `<span>${esc(w)}</span>`).join(' ');
      const spans = Array.from(el.children);
      if (reduce) { spans.forEach((s) => s.classList.add('is-on')); return; }
      const run = () => {
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight;
        const prog = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (vh * 0.55 + r.height * 0.5)));
        const lit = Math.round(prog * spans.length);
        spans.forEach((s, i) => s.classList.toggle('is-on', i < lit));
      };
      window.addEventListener('scroll', () => requestAnimationFrame(run), { passive: true });
      run();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // en el editor de temas, al recargar una sección
  document.addEventListener('shopify:section:load', () => { window.QPagesLoaded = true; init(); });
})();
